module.exports = __webpack_public_path__ + "img/unknown.cd6613bd.svg";